module.exports = __webpack_public_path__ + "e9a35f3be6496e9dfd27e82057ec08ae.jpg";